module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_4.f1bedd4f.png";